import React, { Dispatch, SetStateAction } from 'react';

import {
  Box,
  Button,
  Divider,
  Drawer,
  TextField,
  Typography,
} from '@mui/material';

import { Resource } from '../../../../common/constants/resource';
import styles from '../styles.module.scss';

export const EditPiaDrawer = ({
  isOpen,
  setIsOpen,
  setIsReview,
  setReason,
  reason,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsReview: Dispatch<SetStateAction<boolean>>;
  setReason: Dispatch<SetStateAction<string>>;
  reason: string;
}) => {
  return (
    <Drawer
      open={isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">{Resource.START_PIA}</Typography>
          <Button onClick={() => setIsOpen(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              Close
            </Typography>
          </Button>
        </Box>
        <Divider />
        <Box m={3}>
          <Typography variant="subtitle2" color="textSecondary">
            {Resource.REASON}
          </Typography>
          <TextField
            required
            variant="outlined"
            fullWidth
            multiline
            defaultValue={reason}
            rows={10}
            margin="dense"
            onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
              setReason(ev.currentTarget.value);
            }}
          />
        </Box>
        <Box
          sx={{
            position: 'fixed',
            right: '24px',
            bottom: 0,
            zIndex: 4,
            width: 'calc(375px - 48px)',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            disableElevation
            fullWidth
            sx={{
              textTransform: 'none',
              height: '56px',
              marginBottom: '24px',
            }}
            onClick={() => {
              setIsReview(true);
            }}
            disabled={reason.length <= 0}
          >
            Review Post Issue Audit
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
